/* Animora theme – theme.js (no dependencies) */
(function () {
  'use strict';
  var A = window.Animora || {};
  var S = A.strings || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var fmt = A.moneyFormat || '€{{amount}}';
    var v = (cents / 100);
    var withComma = v.toFixed(2).replace('.', ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v))
      .replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2));
  }

  var overlay = $('[data-overlay]');
  var openDrawer = null;
  function showDrawer(el) {
    if (!el) return;
    closeDrawer();
    el.hidden = false; if (overlay) overlay.hidden = false; openDrawer = el;
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (openDrawer) openDrawer.hidden = true;
    if (overlay) overlay.hidden = true;
    openDrawer = null; document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-menu-open]')) { showDrawer($('[data-menu]')); }
    else if (t.closest('[data-menu-close]') || t.closest('[data-cart-close]')) { closeDrawer(); }
    else if (t.closest('[data-cart-open]') && $('[data-cart-drawer]') && A.cartDrawer !== false) {
      e.preventDefault(); showDrawer($('[data-cart-drawer]'));
    } else if (t.closest('[data-search-toggle]')) {
      var s = $('[data-search]'); s.hidden = !s.hidden; if (!s.hidden) $('input', s).focus();
    }
    var lc = t.closest('[data-line-change]');
    if (lc) { changeLine(lc.getAttribute('data-line-change'), parseInt(lc.getAttribute('data-qty'), 10)); }
  });

  function refreshCart(open) {
    return fetch(A.routes.cart + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        var cur = $('[data-cart-drawer]');
        if (fresh && cur) {
          var wasOpen = !cur.hidden;
          cur.innerHTML = fresh.innerHTML;
          if (open || wasOpen) showDrawer(cur);
        }
        return fetch(A.routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.toggle('is-empty', cart.item_count === 0);
        });
      });
  }
  function changeLine(key, qty) {
    fetch(A.routes.cart_change + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    }).then(function () { refreshCart(false); });
  }
  function toast(msg) {
    var t = document.createElement('div'); t.className = 'toast'; t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 2600);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.hasAttribute('data-ajax-add')) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = S.adding; }
    fetch(A.routes.cart_add + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (A.cartDrawer === false) { toast(S.added); return refreshCart(false); }
        return refreshCart(true);
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || S.error); })
      .finally(function () { if (btn) { btn.disabled = false; btn.innerHTML = label; } });
  });

  var product = $('[data-product]');
  if (product) {
    var data = JSON.parse($('[data-product-json]', product).textContent);
    var form = $('[data-product-form]', product);
    var idInput = $('[data-variant-id]', product);
    var addBtn = $('[data-add-btn]', product);
    var priceWrap = $('[data-price-wrap]', product);
    var track = $('[data-gallery-track]', product);

    var selectedOptions = function () {
      return $$('.option', product).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    };
    var renderPrice = function (v) {
      var sale = v.compare_at_price > v.price;
      var html = '<div class="price price--lg"><span class="price__current' + (sale ? ' price__current--sale' : '') + '">' + formatMoney(v.price) + '</span>';
      if (sale) {
        var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
        html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s><span class="price__save">' + S.save.replace('__PCT__', pct) + '</span>';
      }
      priceWrap.innerHTML = html + '</div>';
      var sp = $('[data-sticky-price]'); if (sp) sp.textContent = formatMoney(v.price);
    };
    var goToMedia = function (id) {
      var slide = track && $('[data-media-id="' + id + '"]', track);
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      $$('[data-thumb]', product).forEach(function (t) { t.classList.toggle('is-active', String(t.getAttribute('data-thumb')) === String(id)); });
    };
    var markAvailability = function (opts) {
      $$('.option', product).forEach(function (fs, i) {
        $$('.pill', fs).forEach(function (pill) {
          var val = $('input', pill).value;
          var ok = data.variants.some(function (v) {
            if (v.options[i] !== val || !v.available) return false;
            for (var j = 0; j < i; j++) if (v.options[j] !== opts[j]) return false;
            return true;
          });
          pill.classList.toggle('is-unavailable', !ok);
        });
      });
    };
    var onChange = function () {
      var opts = selectedOptions();
      $$('.option', product).forEach(function (fs, i) { var l = $('[data-option-label]', fs); if (l) l.textContent = opts[i]; });
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      markAvailability(opts);
      if (!v) { addBtn.disabled = true; addBtn.textContent = S.unavailable; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available; addBtn.textContent = v.available ? S.addToCart : S.soldOut;
      var st = $('[data-sticky-add]'); if (st) st.disabled = !v.available;
      renderPrice(v);
      if (v.featured_media) goToMedia(v.featured_media.id);
      history.replaceState(null, '', product.getAttribute('data-url') + '?variant=' + v.id);
    };
    if (form) form.addEventListener('change', function (e) { if (e.target.name && e.target.name.indexOf('option-') === 0) onChange(); });
    if ($$('.option', product).length) markAvailability(selectedOptions());

    $$('[data-thumb]', product).forEach(function (b) { b.addEventListener('click', function () { goToMedia(b.getAttribute('data-thumb')); }); });
    if (track) {
      var tmr;
      track.addEventListener('scroll', function () {
        clearTimeout(tmr);
        tmr = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          var slide = track.children[i];
          if (slide) $$('[data-thumb]', product).forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-thumb') === slide.getAttribute('data-media-id')); });
        }, 80);
      });
    }

    $$('[data-qty-step]', product).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('[data-qty-input]', product);
        inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
      });
    });

    var del = $('[data-delivery]', product);
    if (del) {
      var addBiz = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6 !== 0) n--; } return d; };
      var f = function (d) { return d.toLocaleDateString(document.documentElement.lang || undefined, { weekday: 'short', day: 'numeric', month: 'short' }); };
      var now = new Date();
      $('[data-delivery-range]', del).textContent = f(addBiz(now, +del.getAttribute('data-min'))) + ' – ' + f(addBiz(now, +del.getAttribute('data-max')));
    }

    var sticky = $('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.hidden = e.isIntersecting || e.boundingClientRect.top > 0;
      }).observe(addBtn);
      $('[data-sticky-add]').addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }
  }

  var recs = $('[data-recommendations]');
  if (recs) {
    fetch(recs.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var el = doc.querySelector('[data-recommendations]');
      if (el && el.innerHTML.trim()) recs.innerHTML = el.innerHTML; else recs.remove();
    });
  }

  var ff = $('[data-filter-form]');
  if (ff) {
    ff.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(ff));
      Array.from(params.keys()).forEach(function (k) { if (!params.get(k)) params.delete(k); });
      location.search = params.toString();
    });
    document.addEventListener('click', function (e) {
      $$('.filter[open]', ff).forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
    });
  }

  $$('[data-rotator]').forEach(function (bar) {
    var msgs = $$('.announcement__msg', bar); if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, 4500);
  });

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.section .section-head, .section .card, .tile, .benefit, .split, .compare__table, .newsletter').forEach(function (el) { el.classList.add('reveal'); io.observe(el); });
  }
})();
